module.exports = __webpack_public_path__ + "img/modal-astro.f33710e3.svg";